import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./style/Contact.css";
import RelifeContactNew from "./homeLayout/RelifeContactNew";
import { AuthContext } from "./auth/AuthProvider";
import axios from "axios";

export default function Contact() {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const { user, googleUser, apiUrl } = useContext(AuthContext);
  // useEffect(() => {
  //   navigate("/");
  //   setTimeout(() => {
  //     const el = document.getElementById("relifeContactNew");
  //     if (el) {
  //       el.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }
  //   }, 600);
  // }, []);

  useEffect(() => {
    // localStorage.setItem("postLoginRedirectTheme", prevLocation);

    if (!user && !googleUser) {
      // localStorage.setItem("postLoginRedirectTheme", prevLocation);
      localStorage.setItem("postLoginRedirect", location.pathname);
      // return;
    }
  }, [user, googleUser, navigate]);

  function handleSubmit(e) {
    e.preventDefault();

    if (!user && !googleUser) {
      navigate("/login");
      return;
    }

    setLoading(true);
    if (user) {
      const messageObj = {
        userUsername: user.username,
        message: message,
      };

      axios
        .post(`${apiUrl}/message/addMessage`, messageObj)
        .then((response) => {
          setMessage("");
        })
        .catch((e) => {
          setError(e.response.data);
          setMessage("");
        })
        .finally(() => setLoading(false));
    }

    if (googleUser) {
      const messageObj = {
        googleEmail: googleUser.email,
        message: message,
      };

      axios
        .post(`${apiUrl}/message/addMessage`, messageObj)
        .then((response) => {
          setMessage("");
        })
        .catch((e) => {
          console.error(e);
          setMessage("");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }

  return (
    <>
      <section id="relifeContactNew">
        {/* HEADER */}
        <div className="contactHeader">
          <h1>Contact Us</h1>
          <p style={{ color: "white" }}>
            We're here to support your journey. Whether you have a question
            about our themes or need technical assistance, reach out and we'll
            be happy to help.
          </p>
        </div>
        {/* INFO BLOCKS */}
        <div className="contactInfo">
          <div className="infoItem">
            <div className="iconCircle">✉️</div>
            <div className="contactEmail">
              <span style={{ color: "black" }}>EMAIL SUPPORT</span>
              <p className="emailSupport">support@introspecta.app</p>
            </div>
          </div>

          <div className="infoItem">
            <div className="iconCircle">💬</div>
            <div className="contactEmail">
              <span style={{ color: "black" }}>COMMUNITY</span>
              <p className="emailSupport">Join our reflection circles</p>
            </div>
          </div>
        </div>

        {/* FORM CARD */}
        <div className="contactFormCard">
          <form onSubmit={handleSubmit}>
            {/* <label>Name</label>
            <input type="text" placeholder="Your name" required />

            <label>Email</label>
            <input type="email" placeholder="you@example.com" required /> */}

            {error ? (
              <p style={{ color: "red", fontWeight: "900" }}>{error}</p>
            ) : (
              ""
            )}
            <label>Message</label>
            <textarea
              placeholder="How can we help?"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />

            <button type="submit" id="messageBtn">
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </section>

      <RelifeContactNew />
    </>
  );
}
